export default "__VITE_ASSET__97ffce5d__"